const CLOSED_STATUSES = ["ended", "winner_announced", "cancelled"];

export const BID_COMMITMENT_COPY =
  "La puja es un compromiso. El pago se coordina en persona al entregar el reloj.";

function getAuctionStatus(product) {
  return product?.auctionStatus ?? product?.status;
}

export function isAuctionOpenForBidding(product, counterValueMs) {
  const auctionStatus = getAuctionStatus(product);
  if (auctionStatus) {
    return auctionStatus === "active";
  }

  return typeof counterValueMs === "number" && counterValueMs > 0;
}

export function isAuctionClosed(product, counterValueMs) {
  const auctionStatus = getAuctionStatus(product);
  if (auctionStatus) {
    return CLOSED_STATUSES.includes(auctionStatus);
  }

  return typeof counterValueMs === "number" && counterValueMs <= 0;
}

export function getMinimumNextBid(product, bids = []) {
  const safeBids = Array.isArray(bids) ? bids : [];
  const pujaSubsecuente = product?.pujaSubsecuente || 0;

  if (typeof product?.precio === "number" && product.precio > 0) {
    return product.precio + pujaSubsecuente;
  }

  if (safeBids.length === 0) {
    return product?.pujaInicial || 0;
  }

  const lastBid = safeBids[safeBids.length - 1]?.bid || 0;
  return lastBid + pujaSubsecuente;
}

export function mapBidErrorMessage(error) {
  const message = error?.message || "Hubo un error en tu solicitud de puja.";
  const outbidMessages = [
    "outbid",
    "auction price changed",
    "Bid rejected",
  ];

  if (error?.errorCode === 409 || outbidMessages.some((part) => message.includes(part))) {
    return "Tu puja fue superada. Actualizamos la subasta; revisa el nuevo monto mínimo e inténtalo de nuevo.";
  }

  if (message.includes("Bid must be at least")) {
    return message;
  }

  if (message.includes("This auction is not open for bidding")) {
    return "Esta subasta ya no está abierta para pujar.";
  }

  if (message.includes("Only customers can place bids")) {
    return "Debes iniciar sesión como cliente para publicar una puja.";
  }

  return message;
}
